import React from "react";
import { useTranslation } from "react-i18next";
import { CancelCrossIcon, Dialog, Header3, IconButton } from "@activecollab/components";
import PropTypes from "prop-types";
import ObjectHistoryDiff from "../ObjectHistory/ObjectHistoryDiff";

export const CommentHistoryDialog = ({ open, onClose, id, parentType, parentId }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      enableBackgroundClick
    >
      <Dialog.Title
        disableDefaultHeading
        className="tw-flex tw-justify-between tw-items-center"
      >
        <Header3>{t("History of Changes")}</Header3>
        <IconButton
          onClick={onClose}
          variant="text gray"
        >
          <CancelCrossIcon />
        </IconButton>
      </Dialog.Title>
      <Dialog.ContentDivider />
      <Dialog.Content>
        <ObjectHistoryDiff
          objectId={id}
          objectType="Comment"
          parentType={parentType}
          parentId={parentId}
        />
      </Dialog.Content>
    </Dialog>
  );
};

CommentHistoryDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  id: PropTypes.number.isRequired,
  parentType: PropTypes.string.isRequired,
  parentId: PropTypes.number.isRequired,
};

CommentHistoryDialog.defaultProps = {
  open: false,
  onClose: () => null,
};
